export default /* css */ `
.heading {
  padding-left: calc(var(--ui-sys-unit) * 24);
}

.project {
  display: flex;
  column-gap: 16px;
  align-items: stretch;

  &:not(:last-child) {
    margin-bottom: calc(var(--ui-sys-unit) * 48);
  }

  ui-card {
    flex: 1;

    --ui-card-content-padding-left: calc(var(--ui-sys-unit) * 24);
    --ui-card-content-padding-right: calc(var(--ui-sys-unit) * 24);
    --ui-card-content-padding-top: calc(var(--ui-sys-unit) * 24);
    --ui-card-content-padding-bottom: calc(var(--ui-sys-unit) * 24);

    &:first-child {
      min-width: 40%;
    }

    &:last-child {
      flex: 2;
    }
  }

  display: flex;

  .project__title {
    font-size: 28px;
    color: hsl(var(--ui-ref-palette-secondary));
    display: block;
    font-weight: 900;
    margin-bottom: calc(var(--ui-sys-unit) * 24);
  }

  .project__content {
    flex: 1;
  }

  .project__image {
    max-height: 380px;
    overflow: hidden;
    display: block;
  }

  .project__footer {
    display: flex;
    justify-content: flex-end;
    margin-top: calc(var(--ui-sys-unit) * 24);

    ui-button {
      display: inline-flex;
    }
  }

  .project__container {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}

ui-page {
  max-width: 120rem;
}

@media screen and (max-width: 820px) {
  .project {
    flex-direction: column;
    row-gap: calc(var(--ui-sys-unit) * 16);
  }
}
`
